import { useEffect, useState } from "react";
import type { Campaign } from "@dm/shared";
import { api } from "./api.js";
import { useApp } from "./appContext.js";

export function InvitePage({ token }: { token: string }) {
  const { reloadMe, fail } = useApp();
  const [info, setInfo] = useState<{ campaign: Campaign; alreadyMember: boolean } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.previewInvite(token).then(setInfo, (err: Error) => setError(err.message));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      await api.acceptInvite(token);
      await reloadMe();
      window.location.hash = "#/character";
    } catch (err) {
      fail(err);
    } finally {
      setBusy(false);
    }
  };

  if (error) return <main className="panel">{error}</main>;
  if (!info) return <main className="muted">Loading…</main>;
  return (
    <main className="panel invite">
      <h3>You're invited to {info.campaign.name}</h3>
      {info.campaign.description && <p>{info.campaign.description}</p>}
      <p className="muted small">Hosted by {info.campaign.ownerName ?? "?"}</p>
      {info.alreadyMember ? (
        <button className="primary" disabled={busy} onClick={accept}>
          You're already in: open it
        </button>
      ) : (
        <button className="primary" disabled={busy} onClick={accept}>
          Join as a Player
        </button>
      )}
    </main>
  );
}
